import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
  SoftSlotDirective,
  TranslatePipe,
} from '@softline/ui-core';
import { AiAgentChatService } from '../../services/ai-agent-chat.service';
import { AiAgentConversationComponent } from '../conversation/conversation.component';

/**
 * Shell trailing-panel host. Rendered by `*ngComponentOutlet` without an
 * injector, so everything it needs must be root-provided.
 */
@Component({
  selector: 'soft-ai-agent-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AiAgentConversationComponent,
    ButtonComponent,
    IconComponent,
    SoftSlotDirective,
    TranslatePipe,
  ],
  template: `
    <div class="actions">
      <soft-ds-button
        type="button"
        variant="ghost"
        size="sm"
        data-testid="ai-agent-panel-new-conversation"
        (click)="newConversation()"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-arrows-rotate" />
        </ng-template>
        {{ '#AI_AGENT.NEW_CONVERSATION' | translate }}
      </soft-ds-button>
    </div>
    <soft-ai-agent-conversation [compact]="true" />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
      gap: 0.5rem;
      padding: 0.75rem;
    }
    .actions {
      display: flex;
      justify-content: flex-end;
    }
    soft-ai-agent-conversation {
      flex: 1;
      min-height: 0;
    }
  `,
})
export class AiAgentPanelComponent {
  private readonly service = inject(AiAgentChatService);

  protected newConversation(): void {
    this.service.reset();
  }
}
